<form name="form" [formGroup]="form" role="search" aria-label="Pesquisa rápida de processos">

  <div class="cdk-barra-pesquisa">
    <div class="barra-pesquisa-custom sm:hidden items-center">
      <button (click)="routeSearch()" mat-icon-button class="custom-search-button"
        aria-label="Abrir pesquisa avançada">
        <mat-icon svgIcon="mat_outline:manage_search" aria-hidden="true"></mat-icon>
      </button>
    </div>

    <div class="barra-pesquisa-final">
      @if (isUserConsultivo) {
        <ng-template #buscaComponent></ng-template>
      }

      <div class="cdk-barra-pesquisa-content xs:hidden">
        <div class="form-field-flex">
          <div class="input-container">
            <label #inputLabel
              [ngClass]="{'floating': form.get('processo')?.value}"
              class="input-label"
              for="processoInput"
              id="processo-label">
              Pesquisa por {{_searchBarService.nomesCampos()}}
            </label>
            <input id="processoInput"
              class="input-field flex grow"
              formControlName="processo"
              (focus)="onFocus()"
              (blur)="onBlur()"
              (input)="onInput()"
              matInput
              [matAutocomplete]="processoSearch.autocomplete()"
              aria-labelledby="processo-label"
              aria-describedby="processo-hint"
              autocomplete="off"
              [attr.aria-expanded]="processoSearch.autocomplete()?.isOpen"
              aria-haspopup="listbox">
            <span id="processo-hint" class="sr-only">Digite o número do processo ou NUP para pesquisar</span>
          </div>
          <cdk-processo-search-autocomplete
            #processoSearch="processoSearchAutocomplete"
            [openBlank]="true"
            [control]="form.get('processo')"
            [pagination]="processoPagination">
          </cdk-processo-search-autocomplete>
        </div>
      </div>
      <ng-template #hiddenComponent></ng-template>
    </div>

  </div>
</form>
